import React, { Component } from 'react'
import './Feedback.css'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { DatePicker, Icon, Alert } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Odata_Url, Constants } from '../../../Constants/Constants'

const axios = require('axios');
const { MonthPicker } = DatePicker;

class Feedback_myself extends Component {
    constructor() {
        super();

        this.state = {
            datafeedback: [],
        }
    }
    componentDidMount() {
        this.onChangeMonth(moment(), moment().format('YYYY-MM'))
    }
    componentWillMount() {
        var date = moment()
        var month = date._d.getMonth() + 1
        var year = date._d.getFullYear()
        var Day = (year + "-" + month)
        this.props.set_MonthPicker(Day)
        const axios = require('axios');
        var state = JSON.parse(window.localStorage.getItem('state'))
        //console.log(state)
        var userid = state.authen.UserID

        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                // console.log(Token)

                axios.get("api/Feedback/GetListOfMySelf?year=" + year + "&month=" + month, {
                    headers: {
                        "Authorization": "Bearer " + Token,
                    }
                }).then(res => {
                    window.localStorage.setItem('feedback', JSON.stringify(res.data));
                    this.setState({ datafeedback: res.data })
                })
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
    }
    showdetail = (feedbackid) => {
        this.props.history.push({
            pathname: "/feedbackdetail",
            state: { feedid: feedbackid, page: "/feedback_myself" }
        });
    }
    onChangeMonth = (date, dateString) => {
        console.log({
            "date": date,
            "dateString": dateString
        });

        var month = date._d.getMonth() + 1
        var year = date._d.getFullYear()

        this.props.set_MonthPicker(dateString)

        axios.get(Constants.BASE_URL + 'auth/token').then((response) => {
            let Token = response.data
            axios.get("api/Feedback/GetListOfMySelf?year=" + year + "&month=" + month, {
                headers: {
                    "Authorization": "Bearer " + Token,
                }
            }).then(res => {
                window.localStorage.setItem('feedback', JSON.stringify(res.data));
                this.setState({ datafeedback: res.data })
            })
        }, (error) => {
            console.log(error);
            if (401 === error.response.status) {
                window.location.href = "auth";
            }
        });
    }

    disabledDate(current) {
        // Can not select days before today and today
        return current && current > moment().endOf('day');
    }

    render() {
        const feedback = this.state.datafeedback;

        var state = JSON.parse(window.localStorage.getItem('state'))
        var month_cache = state.detailMyOb.MonthPicker2
        var date = moment()
        var month = date._d.getMonth() + 1
        var year = date._d.getFullYear()
        var Day = (year + "-" + month)
        // console.log(month_cache)
        if (month_cache === null) {
            Day = (year + "-" + month)
            // alert("null")
        } else {
            Day = this.props.detailMyOb.MonthPicker2
            // alert("Notnull")
        }
        // console.log(month)
        var data_feedback = []
        var count = 0
        feedback.map((l, i) => {
            if (JSON.stringify(l.datetime.slice(0, 7)) === JSON.stringify(Day)) {
                count++;
                data_feedback.push(
                    <button onClick={() => this.showdetail(l.pkFeedbackID)} className="detail" style={{ width: "100%", height: "100px", border: "1px solid whitesmoke", background: "whitesmoke", borderRadius: "5px", marginBottom: "15px" }}>
                        <div style={{ float: "left", width: "100%" }}>
                            <div style={{ position: "relative", width: "100%", textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                <div style={{ display: "inline-block", width: "70%", fontSize: "20px", paddingLeft: "5px" }}>{l.topic}</div>
                                <div style={{ display: "inline-block", width: "30%", fontSize: "16px", textAlign: "right", paddingRight: "5px" }}>{l.status}</div>
                            </div>
                            <div style={{ fontSize: "13px", width: "100%", color: "#000", textAlign: "left", paddingLeft: "5px" }}>
                                {l.detail}
                            </div>
                            <div style={{ fontSize: "13px", width: "100%", color: "#000", textAlign: "left", paddingLeft: "5px" }}>
                                {l.datetime.slice(8, 10) + "-" + l.datetime.slice(5, 7) + "-" + l.datetime.slice(0, 4)} {l.datetime.slice(11, 16)}
                            </div>
                        </div>
                    </button>
                )

            }
            return null
        })
        // console.log(count)
        return (
            <div>
                <ScrollToTop />
                <MenuSider title="My Feedback">
                    <div style={{ padding: "5%" }}>
                        <div style={{ width: "100%", textAlign: "right", marginTop: "15px", marginBottom: "15px" }}>
                            <MonthPicker style={{ width: "35%" }} defaultValue={moment()} onChange={this.onChangeMonth} disabledDate={this.disabledDate} />
                        </div>
                        <div className="feedback-detail">
                            {
                                data_feedback.map((l, i) => {
                                    return (
                                        l
                                    )
                                })
                            }
                        </div>
                        {
                            (count === 0) && (
                                <Alert
                                    message="Informational Notes"
                                    description="there no information to display Try to change filter."
                                    type="info"
                                    showIcon
                                />
                            )

                        }
                        <div style={{ width: "70px", height: "70px", position: "fixed", right: "25px", bottom: "40px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "50%" }}>
                            <Link to={{ pathname: '/newfeedback', state: { foo: 'bar', page: "/feedback_myself" } }}>
                                <Icon type="plus" style={{ left: "25%", top: "25%", position: "relative", color: "white", fontSize: "35px" }} />
                            </Link>
                        </div>
                    </div>
                </MenuSider>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        set_MonthPicker: (value) => {
            dispatch({
                type: "set_MonthPicker2",
                MonthPicker2: value
            })
        }
    }
}

export default connect(mapStatetoProps, mapDispatchProps)(Feedback_myself)